export default __webpack_public_path__ + "static/media/avatar2.fbdd7f16.png";